// @flow

//
// React
//
import React from 'react';

//
// Tenant
//
import { 
    useNavigateTo,
} from '../../../../../../../lib/trix-web-components-tenant';

//
// Material UI
//
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';

//
// Props
//
type Props = {
}

//
// Component
//
const SettingsHeaderItem = (props: Props): any => {
    // Hooks
    const navigateTo = useNavigateTo();
    // End hooks
    
    return (
        <IconButton
            edge='end'
            onClick={() => navigateTo('/settings')}
            color='inherit'
            size="large">
            <SettingsIcon />
        </IconButton>
    );
}
export default SettingsHeaderItem;
